<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            Approval Berjenjang
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow v-if="$helper.isRole($availRoles['HO'])">
      <CCol>
        <b-card no-body>
          <b-tabs card>
            <template #tabs-end v-if="$route.params.by == 'office-type'">
              <b-nav-item @click="redirectPage()">Office</b-nav-item>
            </template>
            <template #tabs-start v-if="$route.params.by == 'office'">
              <b-nav-item @click="redirectPage()">Office Type</b-nav-item>
            </template>
            <b-tab :title="title">
              <CRow>
                <CCol class="ml-5 mt-2">
                  <CForm>
                    <b-input-group v-if="$route.params.by == 'office-type'">
                      <b-input-group-prepend>
                        <b-form-select v-model="officeTypeTable.filterType" :options="officeTypeTable.filterOptions" @change="onChangeFilterTypeOfficeType"></b-form-select>
                      </b-input-group-prepend>
                      <b-input-group-prepend>
                        <b-form-select v-if="officeTypeTable.filterType == 'approverStatus' || officeTypeTable.filterType == 'invoiceApproverStatus'" v-model="officeTypeTable.filterValue" :options="officeTypeTable.filterValueStatusOptions" style="min-width: 206.5px;"></b-form-select>
                        <b-form-input v-else maxlength="50" type="text" placeholder="Search" v-model="officeTypeTable.filterValue"></b-form-input>
                      </b-input-group-prepend>
                      <b-input-group-append>
                        <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterTable">
                          <CIcon name="cil-magnifying-glass" />
                        </CButton>
                      </b-input-group-append>
                    </b-input-group>
                    <b-input-group v-else>
                      <b-input-group-prepend>
                        <b-form-select v-model="officeTable.filterType" :options="officeTable.filterOptions" @change="onChangeFilterTypeOffice"></b-form-select>
                      </b-input-group-prepend>
                      <b-input-group-prepend>
                        <b-form-select v-if="officeTable.filterType == 'approverStatus' || officeTable.filterType == 'invoiceApproverStatus'" v-model="officeTable.filterValue" :options="officeTable.filterValueStatusOptions" style="min-width: 206.5px;"></b-form-select>
                        <b-form-input v-else maxlength="50" type="text" placeholder="Search" v-model="officeTable.filterValue"></b-form-input>
                      </b-input-group-prepend>
                      <b-input-group-append>
                        <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterTable">
                          <CIcon name="cil-magnifying-glass" />
                        </CButton>
                      </b-input-group-append>
                    </b-input-group>
                  </CForm>
                </CCol>
              </CRow>
              <CCard class="custom-card mt-4">
                <CCardBody class="p-0">
                  <template v-if="$route.params.by == 'office-type'">
                    <b-table striped hover show-empty
                      responsive="xl"
                      :items="officeTypeTable.items"
                      :fields="officeTypeTable.fields"
                      :busy="!officeTypeTable.isLoaded"
                      no-local-sorting no-sort-reset
                      @sort-changed="onSortChangedOfficeType"
                    >
                      <template slot="empty">
                        <div v-if="!officeTypeTable.isLoaded" class="text-center">
                          <b-spinner label="Fetching Data..."></b-spinner>
                        </div> 
                        <div v-else class="text-center">
                          Tidak ada data
                        </div> 
                      </template>
                      <template #cell(approverStatus)="row">
                        <CBadge v-if="row.value"
                          color="success"
                        > SET
                        </CBadge>
                        <CBadge v-else
                          color="danger"
                        > UNSET
                        </CBadge>
                      </template>
                      <template #cell(invoiceApproverStatus)="row">
                        <CBadge v-if="row.value"
                          color="success"
                        > SET
                        </CBadge>
                        <CBadge v-else
                          color="danger"
                        > UNSET
                        </CBadge>
                      </template>
                      <template #cell(action)="row">
                        <b-button class="mr-2" variant="primary" size="sm" title="Detail Approval APHT" @click="viewDetailAPHT(row.index, 'apht')">
                          Detail APHT
                        </b-button>
                        <CButton class="mr-2" color="primary" variant="outline" size="sm" title="Detail Approval Invoice APHT" @click="viewDetailAPHT(row.index, 'invoice-apht')">
                          Detail Invoice APHT
                        </CButton>
                        <b-button class="mr-2" variant="danger" size="sm" title="Detail Approval APHT" @click="showAreYouSurePopup(row.index, 'apht')">
                          Clear APHT
                        </b-button>
                        <CButton color="danger" variant="outline" size="sm" title="Detail Approval Invoice APHT" @click="showAreYouSurePopup(row.index, 'invoice-apht')">
                          Clear Invoice APHT
                        </CButton>
                      </template>
                    </b-table>
                    <CCardFooter>
                      <PageSizer :totalRows="officeTypeTable.totalRows" :page="officeTypeTable.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
                    </CCardFooter>
                  </template>
                  <template v-else>
                    <b-table striped hover show-empty
                      responsive="xl"
                      :items="officeTable.items"
                      :fields="officeTable.fields"
                      :busy="!officeTable.isLoaded"
                      no-local-sorting no-sort-reset
                      @sort-changed="onSortChangedOffice"
                    >
                      <template slot="empty">
                        <div v-if="!officeTable.isLoaded" class="text-center">
                          <b-spinner label="Fetching Data..."></b-spinner>
                        </div> 
                        <div v-else class="text-center">
                          Tidak ada data
                        </div> 
                      </template>
                      <template #cell(approverStatus)="row">
                        <CBadge v-if="row.value"
                          color="success"
                        > SET
                        </CBadge>
                        <CBadge v-else
                          color="danger"
                        > UNSET
                        </CBadge>
                      </template>
                      <template #cell(invoiceApproverStatus)="row">
                        <CBadge v-if="row.value"
                          color="success"
                        > SET
                        </CBadge>
                        <CBadge v-else
                          color="danger"
                        > UNSET
                        </CBadge>
                      </template>
                      <template #cell(action)="row">
                        <b-button class="mr-2" variant="primary" size="sm" title="Detail Approval APHT" @click="viewDetailAPHT(row.index, 'apht')">
                          Detail APHT
                        </b-button>
                        <CButton class="mr-2" color="primary" variant="outline" size="sm" title="Detail Approval Invoice APHT" @click="viewDetailAPHT(row.index, 'invoice-apht')">
                          Detail Invoice APHT
                        </CButton>
                        <b-button class="mr-2" variant="danger" size="sm" title="Detail Approval APHT" @click="showAreYouSurePopup(row.index, 'apht')">
                          Clear APHT
                        </b-button>
                        <CButton color="danger" variant="outline" size="sm" title="Detail Approval Invoice APHT" @click="showAreYouSurePopup(row.index, 'invoice-apht')">
                          Clear Invoice APHT
                        </CButton>
                      </template>
                    </b-table>
                    <CCardFooter>
                      <PageSizer :totalRows="officeTable.totalRows" :page="officeTable.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
                    </CCardFooter>
                  </template>
                </CCardBody>
              </CCard>
            </b-tab>
          </b-tabs>
        </b-card>
      </CCol>
    </CRow>

    <CModal :closeOnBackdrop="false" :show.sync="clearApprovalModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Penghapusan Approval Berjenjang</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            <template v-if="clearApprovalModalData.by == 'office-type'">Apakah Anda yakin ingin menghapus Approval Berjenjang {{ clearApprovalModalData.by2 == 'apht' ? 'APHT' : 'Invoice APHT' }} pada semua Office dengan Office Type berikut?</template>
            <template v-else-if="clearApprovalModalData.by == 'office'">Apakah Anda yakin ingin menghapus Approval Berjenjang {{ clearApprovalModalData.by2 == 'apht' ? 'APHT' : 'Invoice APHT' }} dengan Office Code berikut?</template>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Kode
          </CCol>
          <CCol md="8" sm="7">
            : {{ clearApprovalModalData.code }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Nama
          </CCol>
          <CCol md="8" sm="7">
            : {{ clearApprovalModalData.name }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="clearApprovalModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmClearApproval" :disabled="clearApprovalModalData.isLoading">
          <b-spinner small type="grow" v-if="clearApprovalModalData.isLoading" /> 
          {{ clearApprovalModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigApprovalList',
  data() {
    return {

      clearApprovalModalData: {
        isShowing: false,
        code: '',
        name: '',
        by: 'office-type',
        by2: '',
        isLoading: false,
      },

      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      officeTypeTable: {
        isLoaded: false,
        fields: [
          {key: "officeType", label: "Kode", sortable: true},
          {key: "description", label: "Nama", sortable: true},
          {key: "approverStatus", label: "Status APHT", sortable: true},
          {key: "invoiceApproverStatus", label: "Status Invoice APHT", sortable: true},
          {key: "action", label: "Aksi", sortable: false}
        ],

        items: [],

        filterType: "officeType",
        filterOptions: [
          { value: "officeType", text: "Kode" },
          { value: "description", text: "Nama" },
          { value: "approverStatus", text: "Status APHT" },
          { value: "invoiceApproverStatus", text: "Status Invoice APHT" },
        ],
        filterValue: "",

        filterValueStatusOptions: [
          { value: true, text: "SET" },
          { value: false, text: "UNSET" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 1
      },
      officeTable: {
        isLoaded: false,
        fields: [
          {key: "officeCode", label: "Kode", sortable: true},
          {key: "nameFull", label: "Nama", sortable: true},
          {key: "approverStatus", label: "Status APHT", sortable: true},
          {key: "invoiceApproverStatus", label: "Status Invoice APHT", sortable: true},
          {key: "action", label: "Aksi", sortable: false}
        ],

        items: [],

        filterType: "officeCode",
        filterOptions: [
          { value: "officeCode", text: "Kode" },
          { value: "nameFull", text: "Nama" },
          { value: "approverStatus", text: "Status APHT" },
          { value: "invoiceApproverStatus", text: "Status Invoice APHT" },
        ],
        filterValue: "",

        filterValueStatusOptions: [
          { value: true, text: "SET" },
          { value: false, text: "UNSET" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 1
      },
    }
  },
  methods: {

    confirmClearApproval() {
      this.clearApprovalModalData.isLoading = true

      let postUrl
      let data = new FormData()

      if (this.$route.params.by == 'office-type') {
        if (this.clearApprovalModalData.by2 == 'apht') {
          postUrl = '/approver/clearAPHTByOfficeType'
        } else if (this.clearApprovalModalData.by2 == 'invoice-apht'){
          postUrl = '/approver/clearInvoiceAPHTByOfficeType'
        }
        data.set('officeType', this.clearApprovalModalData.code)
      } else if (this.$route.params.by == 'office'){
        if (this.clearApprovalModalData.by2 == 'apht') {
          postUrl = '/approver/clearAPHTByOfficeCode'
        } else if (this.clearApprovalModalData.by2 == 'invoice-apht'){
          postUrl = '/approver/clearInvoiceAPHTByOfficeCode'
        }
        data.set('officeCode', this.clearApprovalModalData.code)
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.post(postUrl, data).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Clear Approval Berjenjang Berhasil! " + (response.data.reason ? response.data.reason : ""))
            
            if (this.$route.params.by == 'office-type') {
              this.getOfficeTypeTableItems(this.officeTypeTable.currentPage)
            } else if (this.$route.params.by == 'office'){
              this.getOfficeTableItems(this.officeTable.currentPage)
            }

            this.clearApprovalModalData.isShowing = false
          }
          else{
            this.$helper.toastError(this, "Clear Approval Berjenjang Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Clear Approval Berjenjang Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Clear Approval Berjenjang Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.clearApprovalModalData.isLoading = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
  
    onSortChangedOfficeType(ctx) {
      this.officeTypeTable.sort.by = ctx.sortBy
      this.officeTypeTable.sort.desc = ctx.sortDesc
      
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])) { 
        this.getOfficeTypeTableItems(this.officeTypeTable.currentPage)
      }
    },

    onSortChangedOffice(ctx) {
      this.officeTable.sort.by = ctx.sortBy
      this.officeTable.sort.desc = ctx.sortDesc

      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])) { 
        this.getOfficeTableItems(this.officeTable.currentPage)
      }
    },

    filterTable(event) {
      event.preventDefault()

      this.$route.params.by == 'office-type' ? this.getOfficeTypeTableItems(this.officeTypeTable.currentPage) : this.getOfficeTableItems(this.officeTable.currentPage)
    },

    onChangeFilterTypeOfficeType() {
      if (this.officeTypeTable.filterType == "approverStatus" || this.officeTypeTable.filterType == "invoiceApproverStatus") {
        this.officeTypeTable.filterValue = true
      } else{
        this.officeTypeTable.filterValue = null
      }
    },

    onChangeFilterTypeOffice() {
      if (this.officeTable.filterType == "approverStatus" || this.officeTable.filterType == "invoiceApproverStatus") {
        this.officeTable.filterValue = true
      } else{
        this.officeTable.filterValue = null
      }
    },

    redirectPage() {
      
      let by = this.$route.params.by == 'office-type' ? 'office' : 'office-type'

      this.$router.push({ name: 'Config Approval List', params: { by: by} })
      if (by == 'office-type') {
        this.title = 'Office Type'
        this.getOfficeTypeTableItems()
      } else{
        this.title = 'Office'
        this.getOfficeTableItems()
      }
    },

    viewDetailAPHT(index, by2) {
      let by = this.$route.params.by == 'office-type' ? 'office-type' : 'office'
      let code = this.$route.params.by == 'office-type' ? this.officeTypeTable.items[index].officeType : this.officeTable.items[index].officeCode

      this.$router.push({ name: 'Config Approval Detail', params: { by: by, by2: by2, code: code } })
    },

    showAreYouSurePopup(index, by2) {
      let by = this.$route.params.by == 'office-type' ? 'office-type' : 'office'
      let code = this.$route.params.by == 'office-type' ? this.officeTypeTable.items[index].officeType : this.officeTable.items[index].officeCode
      let name = this.$route.params.by == 'office-type' ? this.officeTypeTable.items[index].description : this.officeTable.items[index].nameFull

      this.clearApprovalModalData.code = code
      this.clearApprovalModalData.name = name
      this.clearApprovalModalData.by = by
      this.clearApprovalModalData.by2 = by2

      this.clearApprovalModalData.isShowing = true
    },

    onLimitChange(newPerPage) {
      
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$route.params.by == 'office-type' ? this.getOfficeTypeTableItems(newPage) : this.getOfficeTableItems(newPage)
      }
    },

    getOfficeTypeTableItems(page = 1) {
      this.officeTypeTable.isLoaded = false
      this.officeTypeTable.items = []
      if(isNaN(page)) {
        this.officeTypeTable.currentPage = 1
      }
      else {
        this.officeTypeTable.currentPage = page
      }
      // URL builder
      let getUrl = "/approver/getAllOfficeType"
      let params = this.$helper.getBasePagedQuery(this.officeTypeTable.currentPage - 1, this.officeTypeTable.perPage)

      if(!this.$helper.isEmpty(this.officeTypeTable.filterValue)) {
        params['filterType'] = this.officeTypeTable.filterType
        params['filterValue'] = this.officeTypeTable.filterValue
      }
      if(this.officeTypeTable.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.officeTypeTable.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.officeTypeTable.items = response.data.data.data
          this.officeTypeTable.totalRows = response.data.data.totalElements
          this.officeTypeTable.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Office Type Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Office Type Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Office Type Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.officeTypeTable.isLoaded = true
      })
    },

    getOfficeTableItems(page = 1) {
      this.officeTable.isLoaded = false
      this.officeTable.items = []
      if(isNaN(page)) {
        this.officeTable.currentPage = 1
      }
      else {
        this.officeTable.currentPage = page
      }
      // URL builder
      let getUrl = "/approver/getAllOffice"
      let params = this.$helper.getBasePagedQuery(this.officeTable.currentPage - 1, this.officeTable.perPage)

      if(!this.$helper.isEmpty(this.officeTable.filterValue)) {
        params['filterType'] = this.officeTable.filterType
        params['filterValue'] = this.officeTable.filterValue
      }
      if(this.officeTable.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.officeTable.sort, params)
      }

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.officeTable.items = response.data.data.data
          this.officeTable.totalRows = response.data.data.totalElements
          this.officeTable.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Office Type Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.officeTable.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },
  },

  async created(){
    if (this.$route.params.by == 'office-type') {
      this.title = 'Office Type'
      this.getOfficeTypeTableItems()
    } else{
      this.title = 'Office'
      this.getOfficeTableItems()
    }

    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.card-header .nav-item a {
  color: white;
}
.card.custom-card {
  min-height: 300px !important;
}
.card.notes-card {
  border-bottom: 5px solid hsl(210, 3%, 85%) !important;
}
thead {
  font-weight: 500;
}
.table-semicolon {
  min-width: 30px; 
  text-align: center;
}
</style>